import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  AnyQuestion,
  AnythingThatMade,
  AnythingThatMadePlaceholder,
  GettingMostOutOfRiise,
  HelpUs,
  MostCompanies,
  MostCompanies2,
  OrderNextSteps1,
  OrderNextSteps2,
  OrderNextSteps3,
  Submit,
  TeamPreparingOrder,
  ThankYouForYourOrder,
  WelcomeOnboard,
  WhatHappensNext,
} from '../../../Constants';
import PaulAndAle from '../../../assets/ale-and-paul.webp';
import CustomLink from '../../CustomLink';
import ProgressStepper from './ProgressStepper';
import { STEP_FINAL } from '../../../utils/orderCompleteUpsell';

const OrderFinalStep = ({ text, setText, submitFeedback, isLoading }) => {
  const { t } = useTranslation();

  return (
    <div className="t-flex t-flex-col t-gap-4 lg:t-gap-8">
      <ProgressStepper currentStep={STEP_FINAL} />
      <h2 className="t-text-center !t-m-0 t-font-extrabold t-text-secondary">
        {t(ThankYouForYourOrder)}
      </h2>
      <div className="t-flex t-flex-col t-gap-2">
        <p className="!t-m-0 t-text-secondary t-text-lg lg:t-text-xl t-font-extrabold">
          {t(WhatHappensNext)}
        </p>
        <ul className="t-text-sm lg:t-text-base t-list-disc">
          <li>{t(OrderNextSteps1)}</li>
          <li>{t(OrderNextSteps2)}</li>
          <li>{t(OrderNextSteps3)}</li>
        </ul>
      </div>
      <p className="!t-m-0 !t-text-left t-text-sm lg:t-text-base">
        {t(AnyQuestion)}
        <span>
          <a href="mailto:hi@weriise.co" className="t-text-secondary">
            hi@weriise.co
          </a>
        </span>
      </p>
      <div className="t-flex t-flex-col t-gap-1">
        <p className="!t-m-0 t-text-secondary t-text-lg lg:t-text-xl  t-font-extrabold">
          {t(HelpUs)}
        </p>
        <p className="!t-m-0 t-text-sm lg:t-text-base">{t(AnythingThatMade)}</p>
        <textarea
          placeholder={t(AnythingThatMadePlaceholder)}
          className="t-bg-gray-100 t-rounded-lg t-p-2 !t-h-[200px] t-border-2 t-border-gray-300 focus:t-outline-none focus:t-border-secondary"
          rows={6}
          value={text}
          onChange={(event) => setText(event.target.value)}
        />
        <button
          onClick={submitFeedback}
          className="btn btn-secondary !t-bg-quaternary !t-rounded-full !t-w-[250px] !t-mx-auto !t-border-quaternary !t-mt-2"
          disabled={isLoading}
        >
          {t(Submit)}
        </button>
      </div>
      <div className="t-flex t-flex-col">
        <p className="!t-m-0 t-text-secondary t-text-lg lg:t-text-xl  t-font-extrabold">
          {t(GettingMostOutOfRiise)}
        </p>
        <p className="!t-m-0 t-text-sm lg:t-text-base">{t(WelcomeOnboard)}</p>
      </div>
      <div className="t-flex t-flex-col">
        <p className="!t-m-0 t-text-sm lg:t-text-base">{t(MostCompanies)}</p>
        <p className="!t-m-0 t-text-sm lg:t-text-base">{t(MostCompanies2)}</p>
      </div>
      <div className="t-flex t-flex-col">
        <img src={PaulAndAle} alt="" className="!t-rounded-lg" />
        <p className="!t-m-0 t-text-secondary t-text-center t-italic t-text-sm lg:t-text-base">
          {t(TeamPreparingOrder)}
        </p>
      </div>

      <CustomLink
        to="/"
        className="!t-text-sm !t-text-capitalize btn-custom-quaternary !t-px-8 t-py-2 !t-bg-secondary disabled:!t-bg-quaternary hover:!t-text-white !t-max-w-[300px] !t-mx-auto"
      >
        <h6 className="text-center t-m-0">{t('OrderComplete_GoHome')}</h6>
      </CustomLink>
    </div>
  );
};

export default OrderFinalStep;
